Vue.component('test-3-crud-table-row', {
    template: `
        <tr>
            <td>
                <span v-if='row.isEditing === false'>{{ row.valueString }}</span>
                <input v-if='row.isEditing === true' class='form-control text-left' value='' v-model='inputValueString' />
            </td>
            <td class='text-right'>
                <span v-if='row.isEditing === false'>{{ row.valueFloat }}</span>
                <input v-if='row.isEditing === true' class='form-control text-right' value='' v-model='inputValueFloat' />
            </td>
            <td class='text-center'>
                <button class='btn btn-sm btn-primary' v-if='row.isEditing === false' v-on:click='updateStart'>Update</button>
                <button class='btn btn-sm btn-primary' v-if='row.isEditing === false' v-on:click='remove'>Remove</button>
                <button class='btn btn-sm btn-primary' v-if='row.isEditing === true' v-on:click='updateSubmit'>Submit</button>
                <button class='btn btn-sm btn-primary' v-if='row.isEditing === true' v-on:click='updateCancel'>Cancel</button>
            </td>
        </tr>
    `,
    props: {
        row: Object,
    },
    data: function () {
        return {
            inputValueString: '',
            inputValueFloat: '',
        }
    },
    methods: {
        updateStart: function () {

            //Copy the current values into the update fields
            this.inputValueString = this.$props.row.valueString;
            this.inputValueFloat = Number(this.$props.row.valueFloat);

            //Mark as currently editing
            this.$props.row.isEditing = true;
        },
        updateSubmit: function () {
            //Emit the submit event, passing the form field values
            this.$emit('updateSubmit', this.$props.row.id, this.inputValueString, this.inputValueFloat);

        },
        updateCancel: function () {
            this.$props.row.isEditing = false; //For cancel, just clear the fields and cancel with no further action
        },
        remove: function () {
            //Emit the remove event, passing it's own row ID so the parent knows what to remove
            this.$emit('remove', this.$props.row.id);
        }
    },
})